import { styled } from '@mui/material/styles';
import { Container as MuiContainer, Box as MuiBox, Typography } from '@mui/material';

const Container = styled(MuiContainer)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 3),
  },
}));

const Box = styled(MuiBox)(({ theme }) => ({
    'height': '100%',
    'paddingRight': theme.spacing(2),
    'margin-bottom': '200px',
}));

const SubHeader = styled(Typography)(({ theme }) => ({
    fontWeight: 500,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(0.5),
}));

const ParagraphLastChanged = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(6),
    fontStyle: 'italic',
}));

export { Container, Box, SubHeader, ParagraphLastChanged };
